<script setup lang="ts">
  defineOptions({ name: 'AppSidebarFooter' })

  defineProps({
    showBorder: {
      type: Boolean,
      default: true,
    },
  })
</script>

<template>
  <footer
    :class="[
      'app-sidebar-footer flex flex-shrink-0 items-center justify-between gap-2 py-2',
      showBorder ? 'border-r border-default border-solid border-t-0 border-b-0 border-l-0' : '',
    ]"
  >
    <div class="min-w-0 flex-1">
      <slot />
    </div>
  </footer>
</template>
